import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/d_left.svg';
const _withScopeId = n => (_pushScopeId("data-v-6b66598e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "text-[14px] text-white px-[30px] pt-[46px] pb-[20px] max-h-[60vh] relative"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = {
  class: "mx-[14px] text-[18px] text-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-[#F9A51A]"
}, "PP88", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rotate-y-[180deg]"
}, null, -1));
const _hoisted_6 = {
  class: "h-fit text-white px-[30px]"
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "text-right font-bold"
};
import { Popup as VanPopup, Loading as VanLoading } from "vant";
import 'vant/es/dialog/style';
import { ref } from "vue";
import MobilePage from "@/components/MobilePage.vue";
import PcPage from "@/components/PcPage.vue";
import { LiveChatWidget, useWidgetIsReady } from "@livechat/widget-vue";
import { useI18n } from "vue-i18n";
export default {
  __name: 'App',
  setup(__props) {
    const isReady = useWidgetIsReady();
    const {
      locale
    } = useI18n();
    const visible = ref(false);
    const livechatIds = {
      zh_CN: '15165273',
      zh_TW: '15165273',
      en_US: '16359324',
      en_MAS: '16359324',
      vi_VN: '15165414'
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.$isMobile() ? (_openBlock(), _createBlock(MobilePage, {
        key: 0,
        onShowDesc: _cache[0] || (_cache[0] = $event => visible.value = true),
        class: "bg-[#1C1C27]"
      })) : (_openBlock(), _createBlock(PcPage, {
        key: 1,
        onShowDesc: _cache[1] || (_cache[1] = $event => visible.value = true)
      })), _createVNode(_unref(VanPopup), {
        show: visible.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => visible.value = $event),
        "confirm-button-text": _ctx.$t('confirm'),
        closeable: "",
        class: _normalizeClass([_ctx.$isMobile() ? 'w-[90vw]' : '!w-[40vw]', "!bg-[#232939] rounded-[10px]"])
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: _normalizeClass(["flex justify-center items-center", {
            'whitespace-pre pb-[20px]': !_ctx.$isMobile()
          }])
        }, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.$t('word1')), 1), _hoisted_4]), _hoisted_5], 2)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('word2')), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, _toDisplayString(_ctx.$t('word3')), 1), _createElementVNode("li", null, _toDisplayString(_ctx.$t('word4')), 1), _createElementVNode("li", null, _toDisplayString(_ctx.$t('word5')), 1)]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('word6')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('word7')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('team')), 1)])])]),
        _: 1
      }, 8, ["show", "confirm-button-text", "class"]), _createElementVNode("div", {
        class: _normalizeClass(["fixed", _ctx.$isMobile() ? 'bottom-[25px] right-[35px]' : 'bottom-[120px] right-[70px]'])
      }, [!_unref(isReady) ? (_openBlock(), _createBlock(_unref(VanLoading), {
        key: 0,
        color: "#1989fa"
      })) : _createCommentVNode("", true)], 2), _createVNode(_unref(LiveChatWidget), {
        license: livechatIds[_unref(locale)],
        visibility: "minimized"
      }, null, 8, ["license"])], 64);
    };
  }
};